import { ApiService } from '../../../core/services/api-service/api.service';
import { IPromise, IQService } from 'angular';
import { MailboxQuery } from '../shared/mailbox-query';
import { MailsData } from '../shared/mails-data';
import { IMail, Mail } from '../shared/mail';
import { groupBy } from 'lodash-es';
import * as moment from 'moment';
import { IMailsGroupByDate } from '../shared/mails-by-date.interface';
import { BehaviorSubject } from 'rxjs';

export interface IMailsDataRes {
  count: number;
  pages: number;
  messages: IMail[];
}

interface ICashedMails {
  [id: string]: Mail;
}

export class MailboxService {
  static $inject = ['ApiService', '$q'];

  $readEmail: BehaviorSubject<string> = new BehaviorSubject<string>(undefined);
  $readMany: BehaviorSubject<{
    type: string;
    count: number;
  }> = new BehaviorSubject<{ type: string; count: number }>(undefined);

  private cashedMails: ICashedMails = {};

  constructor(private apiService: ApiService, private $q: IQService) {}

  readEmail(type: string) {
    this.$readEmail.next(type);
  }

  readMany(type: string, count: number) {
    this.$readMany.next({type, count});
  }

  getMail(id: string): IPromise<Mail> {
    if (this.cashedMails[id]) {
      return this.$q.resolve(this.cashedMails[id]);
    }
    return this.apiService
      .get<{ message: IMail }>(`/mailbox/${id}`)
      .then((data) => {
        const mail = new Mail(data.message);
        this.cashedMails[id] = mail;
        return mail;
      });
  }

  getMails(params: MailboxQuery): IPromise<MailsData> {
    return this.apiService
      .get<IMailsDataRes>('/mailbox', { params })
      .then((data) => {
        return new MailsData(data);
      });
  }

  addMail(mail: any): IPromise<any> {
    return this.apiService.post<any>('/mailbox/addMessage', mail);
  }

  deleteMail(ids: string | string[], type: string = 'admin'): IPromise<any> {
    const params = { id: ids };
    return this.apiService.delete(`/mailbox`, { params }).then(res => {
      if (Array.isArray(ids)) {
        this.readMany(type, ids.length);
      } else {
        this.readEmail(type)
      }
      return res;
    });
  }

  addToImportant(id: string): IPromise<any> {
    return this.apiService.post(`/mailbox/addToImportant/${id}`);
  }

  deleteFromImportant(id: string): IPromise<any> {
    return this.apiService.post(`/mailbox/deleteFromImportant/${id}`);
  }

  getMailTypes(): IPromise<any> {
    return this.apiService.get('/mailbox/getMailTypes');
  }

  groupMailsByDate(mails: Mail[]): IMailsGroupByDate[] {
    const groupDateMap = groupBy(mails, (mail) => {
      return moment(mail.date)
        .startOf('day')
        .toISOString();
    });
    return Object.keys(groupDateMap).map((date: string) => {
      return {
        date: moment(date),
        mails: groupDateMap[date]
      };
    });
  }
}



// WEBPACK FOOTER //
// ./app/states/mailbox/services/mailbox.service.ts